import { render } from "./ClientInfo.vue?vue&type=template&id=4b369c70&ts=true"
import script from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/ClientInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b369c70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b369c70', __exports__)) {
    api.reload('4b369c70', __exports__)
  }
  
  module.hot.accept("./ClientInfo.vue?vue&type=template&id=4b369c70&ts=true", () => {
    api.rerender('4b369c70', render)
  })

}


export default __exports__